import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import { HallBaseConfig } from "../../../reducers/hallsList.reducer";
import "./HallCard.component.scss";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { AuthorizationServiceTypes } from "../../../../../utils/Authorization/authorizationTypes";
import {
    checkAuthorization,
    checkPermission
} from "./../../../../../utils/Authorization/authorization";
import { ActionCreator } from "../../../../../actions/actions";

export interface HallCardProps {
    hallInfo: HallBaseConfig;
    toggleActiveAction: ActionCreator;
}

function HallCard(props: HallCardProps) {
    const filterLicensedServers = () =>
        props.hallInfo.servers.filter(server => {
            return (
                server.license &&
                server.license.expired == false &&
                server.license.expiration != null
            );
        });

    const filterUnlicensedServers = () =>
        props.hallInfo.servers.filter(
            server =>
                !server.license ||
                server.license.expired == true ||
                server.license.expiration == null
        );

    const filterCertified = () =>
        props.hallInfo.servers.filter(
            server =>
                server.version !== null &&
                server.version > 0 &&
                server.latest_spec_version !== null &&
                server.latest_spec_version > 0 &&
                server.version === server.latest_spec_version
        );

    const hasAnyServerOnline = () =>
        !!props.hallInfo.servers.filter(
            server =>
                server.is_online
        ).length;

    const serversLicensed = filterLicensedServers();
    const serversUnlicensed = filterUnlicensedServers();
    const serversCertified = filterCertified();
    const hasLicensesAccess = checkAuthorization({
        service: AuthorizationServiceTypes.LICENSES
    });

    const serverOnline = hasAnyServerOnline()

    return (
        <div className="info-card">
            <Link to={`/halls/${props.hallInfo.id}`}>
                <div className="hall-card-upper">
                    <div className="hall-card-header">
                        <div>
                            {SubsidiaryUtils.subsidiaryIcon(props.hallInfo.subsidiary)}
                        </div>
                        <div className="header-info">
                            <p>
                                {props.hallInfo.name}
                                {!serverOnline && <i className="icon-wifi-slash-light"/>}
                                {serverOnline && <i className="icon-wifi-solid green"/>}
                            </p>
                            <span>
                                {props.hallInfo.address_line_1},{" "}
                                {props.hallInfo.subsidiary.country.name}
                            </span>
                            <span className="tz">
                                {props.hallInfo.hall_code &&
                                    `HallCode: ${props.hallInfo.hall_code}`}
                            </span>
                            <span className="tz">
                                {props.hallInfo.timezone &&
                                    `TZ: ${props.hallInfo.timezone.timezone}`}
                            </span>
                        </div>
                    </div>
                    <div className="hall-card-body">
                        <ul>
                            {checkPermission("list_servers") && (
                                <li>
                                    <i className={`icon-server-light`}/>
                                    <span>
                                        {props.hallInfo.servers.length} Servers
                                    </span>
                                </li>
                            )}
                            {hasLicensesAccess && (
                                <li>
                                    <i
                                        className={`icon-check-circle-light ${
                                            serversUnlicensed.length == 0 &&
                                            serversLicensed.length > 0
                                                ? "green"
                                                : ""
                                        }`}
                                    />
                                    <span>
                                        {serversLicensed.length}/
                                        {props.hallInfo.servers.length} Licensed
                                    </span>
                                </li>
                            )}
                            {checkPermission("spec_history") && (
                                <li>
                                    <i
                                        className={`icon-file-text ${
                                            serversCertified.length > 0
                                                ? serversCertified.length ==
                                                  props.hallInfo.servers.length
                                                    ? "green"
                                                    : "yellow"
                                                : ""
                                        }`}
                                    />
                                    <span>
                                        {serversCertified.length}/
                                        {props.hallInfo.servers.length}{" "}
                                        Certified
                                    </span>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </Link>
            <div className="hall-card-footer">
                <Link
                    className={"hall-card-link"}
                    to={`/halls/${props.hallInfo.id}`}
                >
                    Details
                </Link>
                {checkPermission("toggle_halls") && (
                    <div className="hall-card-status">
                        <span>
                            {props.hallInfo.active ? "Active" : "Inactive"}
                        </span>
                        <Components.Switch
                            onClick={() =>
                                props.toggleActiveAction(props.hallInfo.id)
                            }
                            on={props.hallInfo.active}
                            enabled
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, null)(HallCard);
